import { render, staticRenderFns } from "./platformGoodsImage.vue?vue&type=template&id=a1199c98&scoped=true"
import script from "./platformGoodsImage.vue?vue&type=script&lang=js"
export * from "./platformGoodsImage.vue?vue&type=script&lang=js"
import style0 from "./platformGoodsImage.vue?vue&type=style&index=0&id=a1199c98&prod&lang=scss&scoped=true"
import style1 from "./platformGoodsImage.vue?vue&type=style&index=1&id=a1199c98&prod&lang=scss&scopd=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1199c98",
  null
  
)

export default component.exports